import { useQuery } from "@tanstack/react-query"
import { FeedbackTopicGet } from "../app/models/FeedbackTopic"
import { digitalManagerApi } from "../services/api"

export function useFeedbackTopics() {
  const { data: feedbackTopicsList = [], isLoading: isLoadingFeedbackTopics } = useQuery({
    queryKey: ["feedbackTopics"],
    queryFn: () =>
      digitalManagerApi.get<FeedbackTopicGet[]>(`/feedbackTopics`).then((r) => r.data),
  })

  return {
    feedbackTopicsList,
    isLoadingFeedbackTopics,
  }
}
